import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable, of, ReplaySubject, Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { maxFileSize } from '../lib/nextcloud/globals';
import { FileService } from '../lib/nextcloud/services/file.service';
import { UploadInputDirective } from '../lib/shared/directives/upload-input.directive';

@Injectable({
  providedIn: 'root'
})
export class RootService {

  private _navbarVisible = new BehaviorSubject(true);
  navbarVisible$ = this._navbarVisible.pipe(debounceTime(5));

  private _uploadInput = new ReplaySubject<UploadInputDirective>(1);

  constructor(
    private _router: Router,
    private _fileService: FileService,
    private _matSnackBar: MatSnackBar
  ) {
    this.setUp();
  }

  hideNavbar = () => this._navbarVisible.next(false);
  registerUploadInput = (directive: UploadInputDirective) => this._uploadInput.next(directive);
  showNavbar = () => this._navbarVisible.next(true);

  setUp() {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) this.showNavbar();
    });
  }

  uploadFiles(folderLocation: string): Observable<Object> {
    let subject = new Subject();
    this._uploadInput.pipe(
      switchMap(directive => directive.trigger()),
      switchMap(files => {
        if (files.length === 0) return of(null);
        let dropped = 0;
        let uploaded = 0;
        let data = new FormData();
        for (let file of (files as any)) {
          if ((file as File).size > maxFileSize) {
            dropped++;
            continue;
          }
          data.append(file.name, file, file.name);
          uploaded++;
        }
        if (uploaded === 0) {
          this._matSnackBar.open(`Es wurde keine Datei hochgeladen. ${dropped} Dateien sind zu groß.`, 'Schließen', {
            duration: 3000
          });
          return of(null);
        }
        return this._fileService.uploadFile(folderLocation, data);
      })
    ).subscribe({
      next: () => subject.next()
    });
    return subject.asObservable();
  }
}
